import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft, Printer } from 'lucide-react'
import { service } from '../lib/api/service'
import type { Project, Surcharge, CombinedEntry } from '../lib/api/types'
import ATASpecPaper from './printSections/ATASpecPaper'

export default function ATASpecPrint() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const sortOrder = parseInt(id ?? '', 10)

  const [data, setData]         = useState<CombinedEntry | null>(null)
  const [project, setProject]   = useState<Project | null>(null)
  const [surcharges, setSurcharges] = useState<Surcharge[]>([])
  const [loading, setLoading]   = useState(true)

  useEffect(() => {
    Promise.all([service.getProject(), service.getAllEntries(), service.getSurcharges()])
      .then(([proj, entries, sc]) => {
        setProject(proj)
        setData(entries.find(e => e.sortOrder === sortOrder) ?? null)
        setSurcharges(sc)
      })
      .finally(() => setLoading(false))
  }, [sortOrder])

  const doPrint = () => {
    document.body.dataset.printing = '1'
    window.print()
    delete document.body.dataset.printing
  }

  if (loading) return <div className="loading"><div className="spinner" /></div>
  if (!data?.ataSpec) return (
    <div className="loading">
      <p style={{ color: 'var(--ink-faint)' }}>ÄTA-specifikation saknas för ÄTA-{String(sortOrder).padStart(3, '0')}.</p>
    </div>
  )

  const nr = `ÄTA-${String(sortOrder).padStart(3, '0')}`

  return (
    <div className="print-overlay">
      <div className="print-toolbar no-print">
        <button className="icon-btn" onClick={() => navigate(`/ata/${sortOrder}`)}>
          <ArrowLeft size={14} /> Tillbaka
        </button>
        <span style={{ fontSize: 13, color: 'var(--ink-dim)' }}>
          ÄTA-specifikation · {nr}
        </span>
        <button className="btn-primary" style={{ marginLeft: 'auto' }} onClick={doPrint}>
          <Printer size={14} /> Skriv ut
        </button>
      </div>

      <ATASpecPaper
        journal={data.journal}
        ataSpec={data.ataSpec}
        project={project}
        surcharges={surcharges}
        sortOrder={sortOrder}
      />
    </div>
  )
}
